import React, { useState, useMemo } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import GamesTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { useIntl } from 'umi';

const ContriesShareCard = (props: any) => {
  const {
    chartType,
    setChartType,
    entityType,
    tableData = [],
    lineData,
    cardStatus,
    tableTotal,
    dateType,
    startDate,
    endDate,
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    tabId,
    setChartLoading,
    chartLoading,
    regionsCountries,
    barOrPieList,
    isGlobal,
    titleNow,
    dataSource,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [chartType, setChartType] = useState('bar');

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_countries_share` })}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-editionsshare-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_countries_share` })}
        activeTab={chartType}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <div className="editionsshare-card-line">
          <Visualis
            chartType={chartType}
            dateType={dateType}
            startDate={startDate}
            endDate={endDate}
            imageType={entityType}
            lineData={lineData}
            isNodata={isNoData}
            metric={tabId}
            chartLoading={chartLoading}
            setChartLoading={setChartLoading}
            topChartsType={'gamesOwned-revenueDownload-game'}
            titleNow={titleNow}
            tableData={barOrPieList} // 不要用tableData, 排序和分页表格数据会变
            gameName={'Countries'}
            regionsCountries={regionsCountries}
          />
        </div>
        {/* 表格头部加table-header-normal没有排序样式  table-header是排序样式*/}

        <GamesTable
          tabId={tabId}
          tableLoading={tableLoading}
          tableTotal={tableTotal}
          tableData={tableData}
          dateType={dateType}
          columnsList={columnsList}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          isGlobal={isGlobal}
          entityType={entityType}
          dataSource={dataSource}
        />
      </CardSlotV2>
    </div>
  );
};

export default ContriesShareCard;
